/**
 *
 * Qlist
 *
 */

export const PageNoMixin = {
  name: 'PageNoMixin',

  computed: {
    c_pageNo() {
      return this.$route.query.pageNo ? Number(this.$route.query.pageNo) : 1;
    },
  },
};

export default PageNoMixin;
